import { render, staticRenderFns } from "./recharges.vue?vue&type=template&id=673f6330&scoped=true&"
import script from "./recharges.vue?vue&type=script&lang=js&"
export * from "./recharges.vue?vue&type=script&lang=js&"
import style0 from "./recharges.vue?vue&type=style&index=0&id=673f6330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673f6330",
  null
  
)

export default component.exports